module.exports = __webpack_public_path__ + "images/f1afaca2a959be14ba7a1d5a6de9fffd.png";